<header class="site-header{{#if solid}} site-header--solid{{/if}}"{{#if interactive}} data-header{{/if}}{{{ root }}}>
  <div class="shell header-inner">
    <a class="brand" href="{{ brandHref }}" aria-label="{{ brandAria }}">
      <span class="brand-mark">FRAWGRAPHY</span>
      <span class="brand-sub"{{{ brandSub.attrs }}}>{{{ brandSub.html }}}</span>
    </a>

    <nav class="tabs" aria-label="Ana bölümler"{{#if interactive}} data-i18n-attr="aria-label:nav.aria"{{/if}}>
      <ul class="tabs-list"{{#if interactive}} data-tabs{{/if}}>
{{#each items}}
        <li{{{ edit }}}><a class="tab" href="{{ href }}"{{#if interactive}} data-tab{{/if}}><span class="tab-label"{{{ label.attrs }}}>{{{ label.html }}}</span></a></li>
{{/each}}
{{#if interactive}}
        <li class="tab-indicator" aria-hidden="true" data-indicator></li>
{{/if}}
      </ul>
    </nav>

    <div class="header-tools">
      <div class="lang-switch" role="group" aria-label="Dil"{{#if interactive}} data-i18n-attr="aria-label:lang.aria"{{/if}}>
        <button type="button" data-lang-btn="tr" aria-pressed="true">TR</button>
        <button type="button" data-lang-btn="en" aria-pressed="false">EN</button>
      </div>

      <button class="theme-toggle" type="button" data-theme-toggle aria-pressed="false">
        <span class="visually-hidden" data-theme-label>Aydınlık temaya geç</span>
        <svg class="icon-sun" viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="4.2"/>
          <path d="M12 2.5v2.2M12 19.3v2.2M4.2 4.2l1.6 1.6M18.2 18.2l1.6 1.6M2.5 12h2.2M19.3 12h2.2M4.2 19.8l1.6-1.6M18.2 5.8l1.6-1.6"/>
        </svg>
        <svg class="icon-moon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M20 14.2A8.2 8.2 0 0 1 9.8 4a8.4 8.4 0 1 0 10.2 10.2z"/>
        </svg>
      </button>

      <button class="menu-toggle" type="button" data-menu-toggle aria-expanded="false" aria-controls="mobile-menu">
        <span class="menu-toggle-label" data-i18n="menu.label">Menü</span>
        <span class="menu-toggle-bars" aria-hidden="true"><i></i><i></i></span>
      </button>
    </div>
  </div>
</header>
